
/*Package importing*/
import React, { Component } from 'react';
import { Link } from 'react-router-dom';

/*Components*/
import SelectBox from '../../components/formComponents/selectBox';
import APILoader from '../../components/other/api-loader';
import NoDataFound from '../../components/other/nothing';

/*Assets*/
import OfferBanner from '../../assets/images/ofr-banner4.jpg';
import OfferLogo from '../../assets/images/purchase-logo.png';
import ViewAdContentModal from '../../components/modals/viewAdContentModal';
import ConfirmationModal from '../../components/modals/confirmationModal';

/*Services*/
import devconfig from '../../config/config.js';
import APIPost from '../../services/apiCall/post';
import APIGet from '../../services/apiCall/get';


class Enquires extends Component {
  constructor(props) {
    super(props);
    this.state = {
      apiLoading: false,
      data: null,
      pageNumActive: true,
      pageNumLoader: false,
      pageNum: 1
    }
  }

  componentDidMount() {
    this.getQuries();
  }

  statusChange = async (id, status) => {
    await this.setState({ status: status });
    this.setState({ statusLoading: id, error: "" });
    let url = devconfig.vendor + 'enquiry/status-update';
    let data = JSON.stringify({
      "id": id,
      "status_id": status.value
    })
    APIPost(url, data).then(function (response) {
      if (response.status == "ok") {
        console.log(response.data);
        this.setState({ data: response.data, statusLoading: "", error: "" });
        this.getQuries();
      }
      else {
        this.setState({ statusLoading: "", error: response.message });
      }
    }.bind(this))
  }

  getQuries() {
    this.setState({ apiLoading: true, error: "" });
    let url = devconfig.vendor + 'enquiry/list';
    APIGet(url).then(function (response) {
      if (response.status == "ok") {
        this.setState({ data: response.data, apiLoading: false, error: "" })
      }
      else {
        this.setState({ apiLoading: false, error: response.message });
      }
    }.bind(this))
  }



  render() {

    const status = [
      { value: 1, label: 'New' },
      { value: 2, label: 'Contacted' },
    ]

    return (
      <div>
        <div className="e-main-content e-vendor-table">
          <h2 className="e-page-head">All Enquires</h2>
          {
            this.state.apiLoading ?
              <div className="container pt-5">
                <APILoader />
              </div>
              : this.state.data && this.state.data.length ?
                <div className="w-100 e-enquiry-table-wrapper">
                  <table className="table  e-enquire-table">
                    <thead>
                      <tr>
                        <th>Date</th>
                        <th>Name</th>
                        <th>Email ID</th>
                        <th>Phone Number</th>
                        <th>For Product</th>
                        <th>Varients Selected</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        this.state.data.map(query => {

                          return (
                            <tr>
                              <td>{query.date}</td>
                              <td>{query.name}</td>
                              <td>{query.email}</td>
                              <td>{query.mobile}</td>
                              <td>{query.product}</td>
                              <td><span className="e-varient-wrap">{query.variant}</span><span className="e-varient-wrap ml-3">{query.choice}</span></td>
                              <td>
                                <SelectBox options={status} selectchange={(value) => this.statusChange(query.id, value)} defaultValue={{ value: query.status_id, label: query.status }} placeholder="Status" isSearchable={false} isDisabled={this.state.statusLoading == query.id} />
                              </td>
                            </tr>
                          )
                        })
                      }
                    </tbody>
                  </table>
                </div>
                :
                <div className="container pt-4 text-center">
                  <NoDataFound head="Nothing Found" />
                </div>
          }

        </div>
      </div>

    );
  }
}

export default Enquires;
